// filterSearchMixin.js
export default {
    methods: {
      filterSearchAdd(filter, value){
        let filter_regex = new RegExp(filter.replace(/@/g, '[^,]+'), 'g');
        if(this.search.match(filter_regex)){
          this.search = this.search.replace(filter_regex, "");
        }
        this.search += "," + filter.replace(/@/g, value);
        this.search = this.search.trim().replace(",,", ",").replace(/^,/g, "").replace(/,$/g, "");
      },
  
      filterSearchClear(){
        this.search = "";
      },
    }
  }